import React from 'react';
import { motion } from 'motion/react';
import styles from './Button.module.css';
import Spinner from './Spinner';
import { SPRING } from '../../utils/motion';

const VARIANTS = ['primary', 'secondary', 'ghost', 'danger', 'cta'];
const SIZES = ['sm', 'md', 'lg'];

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  loading = false,
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}) {
  const v = VARIANTS.includes(variant) ? variant : 'primary';
  const s = SIZES.includes(size) ? size : 'md';
  const inactive = disabled || loading;

  return (
    <motion.button
      type={type}
      disabled={inactive}
      aria-busy={loading || undefined}
      whileHover={inactive ? undefined : { y: -2 }}
      whileTap={inactive ? undefined : { scale: 0.97, y: 0 }}
      transition={SPRING.snappy}
      className={[
        styles.btn,
        styles[v],
        styles[s],
        fullWidth ? styles.full : '',
        loading ? styles.loading : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    >
      {loading && (
        <span className={styles.spinnerSlot}>
          <Spinner size="xs" inline />
        </span>
      )}
      <span className={loading ? styles.labelHidden : ''}>{children}</span>
    </motion.button>
  );
}
